module.exports = __webpack_public_path__ + "static/media/logo.98ca2ca1.png";